import { configurePopover } from '@grapes-agency/ui'

import classes from './Popover.module.scss'

export const Popover = configurePopover({ classes })
